/* Docs: https://valentin.app/discover-tracking.html */
const isViewFromGoogle = () => /\.google/i.test(document.referrer)

export default isViewFromGoogle;